import { SECTION_ID_BLOG, SECTION_ID_TRUE_IMAGE } from '@model/const/blog.ts';

export default {
    computed: {
        translations() {
            return this.$store.state.slices.items?.blog || {};
        },

        isBlog() {
            // First check is to avoid Vue warning about missing component property
            return 'sectionId' in this && this.sectionId === SECTION_ID_BLOG;
        },

        isOnEnLocale() {
            return this.$store.state.geolocation.finalLocale?.startsWith('en');
        },

        enabledLocalesCPC() {
            const toExclude = ['en-eu', 'en-gb', 'en-sg'];
            const languages = this.translations.localeLanguageMapping || {};
            return (this.$store.state.locales.locales || [])
                .filter((locale) => locale.is_active_on_blog_tru && !toExclude.includes(locale.code))
                .map((locale) => ({
                    ...locale,
                    language: languages[locale.code],
                }));
        },
    },

    methods: {
        getSectionName(id) {
            return [SECTION_ID_BLOG, SECTION_ID_TRUE_IMAGE].includes(id) ? 'blog' : 'tru';
        },

        getBlogPostFields(post, translations) {
            if (!post) return null;

            const sectionPath = this.getSectionName(post.section_id);

            return {
                ...post,
                minReadTitle: translations.minRead,
                link: `/${sectionPath}/posts/${post.slug}`,
            };
        },

        getAuthorFields(author) {
            if (!author) return null;

            const socials = [];
            if (author.link_linked_in) {
                socials.push({
                    to: author.link_linked_in,
                    glyph: 'linkedin2',
                });
            }
            if (author.link_twitter) {
                socials.push({
                    to: author.link_twitter,
                    glyph: 'twitter',
                });
            }
            if (author.link_website) {
                socials.push({
                    to: author.link_website,
                    glyph: 'language-select',
                });
            }

            return {
                ...author,
                socials,
                link: `/blog/authors/${author.slug}`,
            };
        },

        getNewsFields(item) {
            if (!item) return null;

            const parentSection = this.getSectionName(item.section_id);
            const link = [parentSection, 'posts', item.slug].filter(Boolean).join('/');
            return {
                ...item,
                link: `/${link}`,
            };
        },

        getCategoryFields(category) {
            if (!category) return null;

            const parentSection = [SECTION_ID_BLOG, SECTION_ID_TRUE_IMAGE].includes(category.section_id)
                ? 'blog'
                : 'tru';
            const link = [parentSection, 'categories', category.slug].filter(Boolean).join('/');
            return {
                id: category.id,
                title: category.title,
                link: `/${link}`,
            };
        },
    },
};
